import { atom } from 'recoil';

// MAC 액세스 토큰은 httpOnly 쿠키라 JS에서 읽을 수 없다.
// 그래서 로그인 여부를 판단할 읽기 가능한 "힌트"를 localStorage 에 동기화해 둔다.
// (토큰 자체가 아니라 단순 boolean 플래그 — 보안 영향 없음)
const AUTH_HINT_KEY = 'mac_auth';

export const hasAuthHint = (): boolean => {
    try {
        return localStorage.getItem(AUTH_HINT_KEY) === '1';
    } catch {
        return false;
    }
};

const persistAuthHint = (value: boolean): void => {
    try {
        if (value) {
            localStorage.setItem(AUTH_HINT_KEY, '1');
        } else {
            localStorage.removeItem(AUTH_HINT_KEY);
        }
    } catch {
        // localStorage 사용 불가 환경 — 무시
    }
};

export const isLoggedInAtom = atom<boolean>({
    key: 'isLoggedIn',
    default: hasAuthHint(),
    effects: [
        ({ onSet }) => {
            // 로그인/로그아웃으로 상태가 바뀔 때마다 힌트를 동기화
            onSet((newValue) => persistAuthHint(newValue));
        },
    ],
});

export const userAtom = atom<User | null>({
    key: 'user',
    default: null,
});
